import {useInitViewer} from '../state/viewer/hooks';
import {useConsentAwareAnalyticsInjection} from '../util/consentAwareAnalyticSetup';
import {useDatadogUserSetup} from '../util/datadog/useDatadogUserSetup';

export const AppViewerLifecycle = () => {
  // Preserve the existing lifecycle order: consent setup first, viewer state
  // synchronization second, and Datadog user setup last.
  useConsentAwareAnalyticsInjection();
  useInitViewer();
  useDatadogUserSetup();
  return null;
};
